/* unplugin-vue-components disabled */import script from "./CompetitionLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionLayout.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionLayout.vue?vue&type=style&index=0&id=126235be&lang=less"

const __exports__ = script;

export default __exports__